import { render, staticRenderFns } from "./jftDown.vue?vue&type=template&id=dadd3ece&scoped=true&"
import script from "./jftDown.vue?vue&type=script&lang=js&"
export * from "./jftDown.vue?vue&type=script&lang=js&"
import style0 from "./jftDown.vue?vue&type=style&index=0&id=dadd3ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadd3ece",
  null
  
)

export default component.exports